/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_BackInputs */

const en_us2_search_back = /** @type {(inputs: Search_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back`)
};

const pt_br2_search_back = /** @type {(inputs: Search_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voltar`)
};

const es_419_search_back = /** @type {(inputs: Search_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volver`)
};

const pt_pt2_search_back = /** @type {(inputs: Search_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voltar`)
};

const fr_fr2_search_back = /** @type {(inputs: Search_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retour`)
};

const de_de2_search_back = /** @type {(inputs: Search_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurück`)
};

const it_it2_search_back = /** @type {(inputs: Search_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indietro`)
};

/**
* | output |
* | --- |
* | "Back" |
*
* @param {Search_BackInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_back = /** @type {((inputs?: Search_BackInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_BackInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_back(inputs)
	if (locale === "es-419") return es_419_search_back(inputs)
	if (locale === "pt-PT") return pt_pt2_search_back(inputs)
	if (locale === "fr-FR") return fr_fr2_search_back(inputs)
	if (locale === "de-DE") return de_de2_search_back(inputs)
	if (locale === "it-IT") return it_it2_search_back(inputs)
	return en_us2_search_back(inputs)
});
export { search_back as "search.back" }